'use client'
import { useEffect, useState } from 'react'

/* ── SVG Icon set ── */
const Icon = {
  Finance: () => (
    <svg viewBox="0 0 20 20" fill="none" className="w-4 h-4" stroke="currentColor" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 3v1m0 12v1M5.05 5.05l.707.707m8.485 8.485.707.707M3 10h1m12 0h1M5.757 14.243l.707-.707M13.536 6.464l.707-.707" />
      <circle cx="10" cy="10" r="3" />
    </svg>
  ),
  Marketing: () => (
    <svg viewBox="0 0 20 20" fill="none" className="w-4 h-4" stroke="currentColor" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 8A8 8 0 1 1 8 16" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 4l4 4-4 4" />
    </svg>
  ),
  HR: () => (
    <svg viewBox="0 0 20 20" fill="none" className="w-4 h-4" stroke="currentColor" strokeWidth={1.6}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M10 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-7 7a7 7 0 0 1 14 0" />
    </svg>
  ),
  Bot: () => (
    <svg viewBox="0 0 24 24" fill="none" className="w-7 h-7" stroke="currentColor" strokeWidth={1.5}>
      <rect x="3" y="8" width="18" height="13" rx="3" />
      <path strokeLinecap="round" d="M12 8V5" />
      <circle cx="12" cy="4" r="1.5" />
      <circle cx="8.5" cy="14" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="15.5" cy="14" r="1.5" fill="currentColor" stroke="none" />
      <path strokeLinecap="round" d="M9 17.5h6" />
      <path strokeLinecap="round" d="M3 13h1m16 0h1" />
    </svg>
  ),
  Lightning: () => (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-3.5 h-3.5">
      <path d="M9.5 1.5 3 9h5l-1.5 5.5L14 7H9L9.5 1.5z" />
    </svg>
  ),
}

const tasks = [
  {
    IconComp: Icon.Finance,
    iconBg: '#dcfce7',
    iconColor: '#16a34a',
    name: 'Monthly P&L report',
    dept: 'Finplix · Finance',
    badge: 'Done',
    badgeCls: 'bg-green-100 text-green-700',
  },
  {
    IconComp: Icon.Marketing,
    iconBg: '#fef3c7',
    iconColor: '#d97706',
    name: 'Q2 campaign brief',
    dept: 'Markplix · Marketing',
    badge: 'Live',
    badgeCls: 'bg-amber-100 text-amber-700',
  },
  {
    IconComp: Icon.HR,
    iconBg: '#eff6ff',
    iconColor: '#2563eb',
    name: 'Hiring plan review',
    dept: 'Hirplix · HR',
    badge: 'Queued',
    badgeCls: 'bg-gray-100 text-gray-500',
  },
]

const miniAgents = [
  { name: 'Finplix',   color: '#22c55e' },
  { name: 'Hirplix',   color: '#3b82f6' },
  { name: 'Salesplix', color: '#f59e0b' },
  { name: 'Markplix',  color: '#8b5cf6' },
]

export default function OrgChart() {
  const [count, setCount] = useState(247)

  useEffect(() => {
    const t = setInterval(() => setCount(c => c + Math.floor(Math.random() * 2)), 4000)
    return () => clearInterval(t)
  }, [])

  return (
    <div className="flex flex-col items-center gap-0 select-none">

      {/* ── Human Card — LARGE ── */}
      <div className="bg-[#1a1a1a] text-white rounded-[22px] px-6 py-5 flex items-center gap-5 shadow-2xl min-w-[270px]">
        {/* Photo — bigger */}
        <div className="relative flex-shrink-0 w-[96px] h-[96px] rounded-2xl overflow-hidden border-[3px] border-[#3a3a3a] shadow-lg">
          <img src="/manager-photo.jpg" alt="Manager" className="w-full h-full object-cover" style={{ objectPosition: "center top" }} />
        </div>
        <div>
          <div className="text-[17px] font-extrabold tracking-tight">You</div>
          <div className="text-[12px] text-gray-400 mt-0.5">Manager · Your Company</div>
          <div className="mt-2 inline-flex items-center gap-1.5 bg-[#252525] border border-[#383838] rounded-full px-3 py-1">
            <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block" />
            <span className="text-[10px] text-gray-400 uppercase tracking-wider font-semibold">Leads the team</span>
          </div>
        </div>
      </div>

      {/* Connector */}
      <div className="w-0.5 h-8 bg-gray-300 dark:bg-gray-600" />

      {/* ── Eve Card ── */}
      <div className="bg-white dark:bg-gray-900 rounded-[22px] w-[300px] sm:w-[320px] shadow-xl ring-1 ring-black/5 overflow-hidden">

        {/* Dark header */}
        <div className="relative bg-gradient-to-br from-[#1a1a1a] to-[#2d2d2d] px-5 pt-5 pb-4 overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(34,197,94,0.12),transparent_60%)]" />

          <div className="relative flex items-center gap-3.5">
            {/* Bot avatar with ring */}
            <div className="relative flex-shrink-0">
              <div className="w-14 h-14 rounded-full border-2 border-[#383838] overflow-hidden flex-shrink-0">
                <img src="/eve-bot.png" alt="Eve" className="w-full h-full object-cover" />
              </div>
              <div
                className="absolute inset-[-4px] rounded-full border-2 border-transparent border-t-green-500 border-r-green-500/20 animate-spin"
                style={{ animationDuration: '3s' }}
              />
              <div className="absolute bottom-0.5 right-0.5 w-3 h-3 bg-green-500 rounded-full border-2 border-[#1a1a1a] animate-pulse" />
            </div>

            <div>
              <div className="text-[16px] font-extrabold text-white tracking-tight">Eve</div>
              <div className="text-[11px] text-gray-500 mt-0.5">AI Chief of Staff · All Departments</div>
              <div className="flex items-center gap-1.5 mt-1.5">
                <div className="flex items-center gap-1 bg-green-500/15 border border-green-500/30 rounded-full px-2 py-0.5 text-[10px] text-green-400 font-semibold">
                  <span className="w-1 h-1 rounded-full bg-green-500 animate-pulse inline-block" />
                  Working now
                </div>
                <div className="bg-white/8 border border-white/10 rounded-full px-2 py-0.5 text-[10px] text-gray-400">
                  24/7
                </div>
              </div>
            </div>
          </div>

          {/* Live activity bar */}
          <div className="relative mt-3.5 bg-white/4 border border-white/8 rounded-xl px-3 py-2 flex items-center gap-2">
            <span className="text-amber-400 flex-shrink-0"><Icon.Lightning /></span>
            <span className="text-[11px] text-gray-400 flex-1 truncate">
              Drafting <strong className="text-white font-semibold">Q2 hiring plan</strong> for Hirplix
            </span>
            <span className="text-[10px] text-gray-600 flex-shrink-0">just now</span>
          </div>
        </div>

        {/* White body */}
        <div className="px-5 py-4">

          {/* Stats */}
          <div className="grid grid-cols-3 gap-2 mb-4">
            {[
              { val: count.toString(), lbl: 'Tasks today' },
              { val: '<10s',           lbl: 'Response' },
              { val: '21',             lbl: 'Agents led' },
            ].map(s => (
              <div key={s.lbl} className="bg-gray-50 dark:bg-gray-800 rounded-xl py-2.5 text-center">
                <div className="text-[15px] font-extrabold text-[#1a1a1a] dark:text-white tracking-tight">{s.val}</div>
                <div className="text-[9px] uppercase tracking-wide text-gray-400 mt-0.5">{s.lbl}</div>
              </div>
            ))}
          </div>

          {/* Task feed */}
          <div className="text-[10px] uppercase tracking-widest text-gray-400 font-bold mb-2">Recent tasks</div>
          <div className="flex flex-col gap-1.5">
            {tasks.map(t => (
              <div key={t.name} className="flex items-center gap-2.5 bg-gray-50 dark:bg-gray-800 rounded-xl px-2.5 py-2">
                <div
                  className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: t.iconBg, color: t.iconColor }}
                >
                  <t.IconComp />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[11px] font-semibold text-[#1a1a1a] dark:text-white truncate">{t.name}</div>
                  <div className="text-[10px] text-gray-400 mt-0.5">{t.dept}</div>
                </div>
                <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full flex-shrink-0 ${t.badgeCls}`}>{t.badge}</span>
              </div>
            ))}
          </div>

          {/* Typing */}
          <div className="mt-3 flex items-center gap-2 bg-gray-100 dark:bg-gray-800 rounded-xl px-3 py-2">
            <span className="text-[10px] text-gray-400">Eve is responding…</span>
            <div className="flex gap-1 items-center">
              {[0, 150, 300].map(d => (
                <span
                  key={d}
                  className="w-1 h-1 rounded-full bg-gray-400 animate-bounce inline-block"
                  style={{ animationDelay: `${d}ms` }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Connector 2 */}
      <div className="w-0.5 h-6 bg-gray-300 dark:bg-gray-600" />
      <div className="text-[9px] uppercase tracking-widest text-gray-400 mb-2.5">Eve manages your full team</div>

      {/* Mini agents */}
      <div className="flex gap-2 flex-wrap justify-center max-w-[340px]">
        {miniAgents.map(a => (
          <div
            key={a.name}
            className="bg-white dark:bg-gray-900 rounded-xl px-3 py-2 flex items-center gap-2 text-xs font-semibold text-[#1a1a1a] dark:text-white shadow-sm ring-1 ring-black/5"
          >
            <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: a.color }} />
            {a.name}
          </div>
        ))}
        <div className="bg-[#1a1a1a] text-white rounded-xl px-3.5 py-2 text-xs font-semibold shadow-md">
          +17 more →
        </div>
      </div>
    </div>
  )
}
